<template>
  <div class="expande-horizontal column pt-0">
    <v-flex xs12>
      <div class="windows-style expande-horizontal fonte column">
        <transition name="slide-fade">
          <v-list-item class="pa-0 ma-0">
            <v-avatar
              @click="backToList"
              style="cursor: pointer;"
              size="27"
              :color="$theme.primary"
              class="mr-2"
              icon
            >
              <v-icon color="#333">mdi-close</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="">
                Avaliado: {{ get_evaluation.student.nome }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-mini">
                Tempo total: {{ get_evaluation.time_total | formatTime }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="get_evaluation._id">
              <v-btn
                color="red"
                @click="excluir_evaluation_dialog(get_evaluation)"
                outlined
                small
                >Excluir</v-btn
              >
            </v-list-item-action>
          </v-list-item>
        </transition>
      </div>
    </v-flex>
    <div class="windows-style-content expande-horizontal wrap">
      <v-flex xs12>
        <div
          style="min-height: 12vh; max-height: 78vh; overflow: auto;"
          class="expande-horizontal centraliza"
        >
          <v-list
            style="min-height: 12vh; max-height: 78vh; overflow: auto;"
            color="transparent"
          >
            <template v-for="(_step, index) in get_evaluation.steps">
              <v-list-item class="px-3" :key="`step-result-${_step.step}`">
                <v-avatar color="#e5e5e5" class="mr-3" rounded size="100">
                  <v-img
                    v-if="_step.moviment_description_image"
                    :src="_step.moviment_description_image"
                  ></v-img>
                  <v-icon v-else>mdi-image-outline</v-icon>
                </v-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <span class="fonte" style="font-size: 12pt !important;"
                      >Categoria: {{ _step.category }}</span
                    >
                  </v-list-item-title>
                  <span class="fonte" style="font-size: 12pt !important;"
                    >Instrução: {{ _step.task }}</span
                  >
                  <span
                    v-if="_step.showPointsChoise"
                    class="fonte"
                    style="font-size: 12pt !important;"
                    >Nota: {{ _step.evaluation_note }}</span
                  >
                  <span
                    v-if="_step.showMembersChoise"
                    class="fonte"
                    style="font-size: 12pt !important;"
                    >Membro: {{ _step.member }}</span
                  >
                  <span
                    v-if="_step.showTextField"
                    class="fonte"
                    style="font-size: 12pt !important;"
                    >{{ _step.textFieldPlaceholder }}:
                    {{ _step.textFieldData }}</span
                  >
                  <span
                    v-if="_step.showTextField2"
                    class="fonte"
                    style="font-size: 12pt !important;"
                    >{{ _step.textFieldPlaceholder2 }}:
                    {{ _step.textFieldData2 }}</span
                  >
                  <span class="fonte" style="font-size: 12pt !important;"
                    >Tempo: {{ _step.total_step_time_formatted }}</span
                  >
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="index"></v-divider>
            </template>
          </v-list>
        </div>
      </v-flex>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["get_evaluation", "getLoggedUser"])
  },
  filters: {
    formatTime(value) {
      const minutes = Math.floor(value / 60);
      const seconds = value % 60;
      return `${minutes}m ${seconds}s`;
    }
  },
  methods: {
    ...mapActions([
      "criar_evaluation",
      "atualizar_evaluation",
      "fecha_modal_view_evaluation",
      "createConfirmAction"
    ]),
    excluir_evaluation_dialog() {
      this.createConfirmAction({
        message: "Deseja realmente excluir?",
        color: "red",
        action: "excluir_evaluation",
        action_value: { _id: this.get_evaluation._id }
      });
    },
    valida_form() {
      if (this.$refs.form.validate()) {
        this.get_evaluation._id
          ? this.atualizar_evaluation()
          : this.criar_evaluation();
      }
    },
    backToList() {
      this.$store.commit("set_evaluation", {});
      this.$forceUpdate();
    }
  }
};
</script>
